import React, { createContext, useContext, useState, useEffect } from 'react';
import Spinner from '../components/ui/Spinner';

interface AdminAuthContextType {
  adminId: string | null;
  adminToken: string | null;
  userLevel: string | null;
  setAdminAuth: (adminId: string, token: string, userLevel: string) => void;
  logoutAdmin: () => void;
}

const AdminAuthContext = createContext<AdminAuthContextType>({
  adminId: null,
  adminToken: null,
  userLevel: null,
  setAdminAuth: () => {},
  logoutAdmin: () => {},
});

export const AdminAuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [adminId, setAdminId] = useState<string | null>(null);
  const [adminToken, setAdminToken] = useState<string | null>(null);
  const [userLevel, setUserLevel] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedId = localStorage.getItem('admin_id');
    const storedToken = localStorage.getItem('admin_token');
    const storedUserLevel = localStorage.getItem('user_level');
    if (storedId && storedToken && storedUserLevel) {
      setAdminId(storedId);
      setAdminToken(storedToken);
      setUserLevel(storedUserLevel);
    }
    setLoading(false);
  }, []);

  const setAdminAuth = (id: string, token: string, userLevel: string) => {
    setAdminId(id);
    setAdminToken(token);
    setUserLevel(userLevel);
    localStorage.setItem('admin_id', id);
    localStorage.setItem('admin_token', token);
    localStorage.setItem('user_level', userLevel);
  };

  const logoutAdmin = () => {
    setAdminId(null);
    setAdminToken(null);
    setUserLevel(null);
    localStorage.removeItem('admin_id');
    localStorage.removeItem('admin_token');
    localStorage.removeItem('user_level');
  };

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '0.6rem',
          minHeight: '100vh',
          color: 'var(--muted)',
          fontFamily: 'var(--font-body)',
        }}
      >
        <Spinner />
        Carregando sessão de admin...
      </div>
    );
  }

  return (
    <AdminAuthContext.Provider value={{ adminId, adminToken, userLevel, setAdminAuth, logoutAdmin }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => useContext(AdminAuthContext);